<template>
  <div class="vx-card">
    <div class="vx-card__body card-body">
      <div class="flex flex-col">
        <div class="flex items-end justify-end flex-wrap gap-4 gap-y-6 pb-4">
          <div class="w-full flex-grow sm:w-1/3 lg:w-1/4 relative">
            <label class="text-sm">{{ $t("ItemCode") }}*</label>
            <vs-input
              name="itemCode"
              v-validate="{ required: true }"
              v-model="gridSearchData.itemCode"
              @keyup.enter="submitFilter"
              :class="[errors.has('itemCode') ? 'error-input' : '']"
              v-trim-space
            />
            <span
              v-show="errors.has('itemCode')"
              style="top: 102%"
              class="absolute text-danger text-sm"
              >{{ errors.first("itemCode") }}</span
            >
          </div>
          <div class="w-full sm:w-1/3 lg:w-1/4 flex-shrink">
            <label class="text-sm">{{ $t("AgentCode") }}</label>
            <vs-input
              v-model="gridSearchData.saleAgentCode"
              @keyup.enter="submitFilter"
              v-trim-space
            />
          </div>
          <div class="w-full sm:w-1/3 lg:w-1/4 flex-shrink">
            <label class="text-sm">{{ $t("AgentName") }}</label>
            <vs-input
              v-model="gridSearchData.saleAgentName"
              @keyup.enter="submitFilter"
              v-trim-space
            />
          </div>
          <div class="flex-grow">
            <div class="flex justify-end gap-4">
              <vs-button
                type="filled"
                style="background: #3ec9d6 !important"
                @click.prevent="resetForm"
                >{{ $t("ResetFilter") }}</vs-button
              >
              <vs-button type="filled" @click.prevent="submitFilter">{{
                $t("SubmitFilter")
              }}</vs-button>
            </div>
          </div>
        </div>
        <div class="pt-4" v-if="showTable">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('TransactionType') },
                { title: $t('ItemCode') },
                { title: $t('AgentName') },
                { title: $t('AgentCode') },
                { title: $t('Segment') },
                { title: $t('ContractName') },
                { title: $t('Date') },
                { title: $t('Count') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 10%">
                  {{ row.type }}
                </td>
                <td style="width: 10%">
                  {{ row.itemCode }}
                </td>
                <td style="width: 15%">
                  {{ row.saleAgentName }}
                </td>
                <td style="width: 15%">
                  {{ row.saleAgentCode }}
                </td>
                <td style="width: 10%">
                  {{ row.segmentName }}
                </td>
                <td style="width: 15%">
                  {{ row.contractTitle }}
                </td>
                <td style="width: 15%; direction: ltr">
                  {{ row.persianDateTime.split(" ")[0] }}<br />{{
                    row.persianDateTime.split(" ")[1]
                  }}
                </td>
                <td
                  style="width: 10%; direction: ltr"
                  :style="{
                    backgroundColor:
                      row.type == 'شارژ'
                        ? 'rgba(0, 163, 2, 0.2)'
                        : 'rgba(209, 27, 27, 0.2)',
                  }"
                  class="text-lg"
                >
                  {{ row.type == "شارژ" ? "+" : "-" }}{{ row.count }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataGrid from "@/components/datagrid/DataGrid";
import { Validator } from "vee-validate";

const dict = {
  custom: {
    itemCode: {
      required: "لطفا کد کالا را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);

export default {
  name: "saleManagment_Quotas_Transactions",
  components: {
    DataGrid,
  },
  data() {
    return {
      gridDataSource: {
        type: "app",
        service:
          "Sales/api/QuotaTransactionsQuery/sale-agent-quota-transactions-with-item-code",
      },
      gridSearchData: {
        itemCode: "",
      },
      showTable: false,
    };
  },
  methods: {
    submitFilter() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (!this.showTable) {
            this.showTable = true;
          } else {
            setTimeout(() => {
              this.$refs.grid.renderGrid(1, true);
            }, 0);
          }
        }
      });
    },
    resetForm() {
      this.gridSearchData = {};
      this.showTable = false;
      this.$validator.reset();
    },
  },
};
</script>
<style>
body[dir="rtl"] .error-input .vs-input--input.normal {
  border-color: red !important;
}
</style>
<style scoped>
.charge {
  background-color: rgba(76, 194, 26, 0.3) !important;
}
.discharge {
  background-color: rgba(209, 27, 27, 0.3) !important;
}
</style>
